import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';
import { 
  obterTiposLojas
} from '../../../data/empresas';

const FilterSidebar = ({ 
  categories: selectedCategories,
  onFilterChange, 
  onClearFilters, 
  searchTerm, 
  onSearchChange,
  isFilterOpen,
  onClose 
}) => {
  // Obter tipos únicos de lojas com suas contagens
  const tiposLojas = obterTiposLojas();

  // Função para normalizar o tipo para ID (deve ser consistente com a filtragem)
  const normalizarTipoParaId = (tipo) => {
    return tipo
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[\/]/g, '-')
      .replace(/&/g, 'e')
      .trim();
  };

  // Função para encurtar o nome da categoria para exibição
  const encurtarCategoria = (tipo) => {
    const encurtamentos = {
      'Agropecuária e Pet Shop': 'Agropecuária & Pet',
      'Ateliê de costura': 'Ateliê de Costura',
      'Bar e Restaurante': 'Bar & Restaurante',
      'Barbearia': 'Barbearia',
      'Distribuidora de Bebidas': 'Distribuidora',
      'Estúdio de Musculação e Pilates': 'Estúdio Fitness',
      'Loja para jardim e plantas / Agência de envios': 'Jardim & Envios',
      'Manutenção e Reparos': 'Manutenção',
      'Material de construção': 'Material Construção',
      'Restaurante': 'Restaurante',
      'Sorveteria e açaí': 'Sorveteria & Açaí'
    };
    
    return encurtamentos[tipo] || tipo;
  };

  const categories = tiposLojas.map(({ tipo, count }) => ({
    id: normalizarTipoParaId(tipo),
    label: encurtarCategoria(tipo),
    tipoOriginal: tipo, // Manter o tipo original para referência
    count: count
  }));

  const handleCategoryChange = (categoryId, checked) => {
    const newCategories = checked 
      ? [...selectedCategories, categoryId]
      : selectedCategories?.filter(id => id !== categoryId);
    onFilterChange('categories', newCategories);
  };

  const getActiveFiltersCount = () => {
    return selectedCategories?.length;
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isFilterOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}
      {/* Sidebar */}
      <div className={`
        fixed lg:sticky top-0 left-0 h-full lg:h-auto w-80 bg-background border-r border-border z-50 lg:z-auto
        transform transition-transform duration-300 ease-in-out lg:transform-none
        ${isFilterOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        overflow-y-auto lg:overflow-visible
      `}>
        <div className="p-6">
          {/* Mobile Header */}
          <div className="flex items-center justify-between mb-6 lg:hidden">
            <h2 className="text-lg font-heading font-semibold text-foreground">
              Filtros
            </h2>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
            >
              <Icon name="X" size={20} />
            </Button>
          </div>

          {/* Search */}
          <div className="mb-6">
            <Input
              type="search"
              placeholder="Buscar lojas..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full"
            />
          </div>

          {/* Filter Header */}
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-sm font-medium text-foreground">
              Filtros {getActiveFiltersCount() > 0 && `(${getActiveFiltersCount()})`}
            </h3>
            {getActiveFiltersCount() > 0 && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onClearFilters}
                className="text-xs"
              >
                Limpar
              </Button>
            )}
          </div>

          {/* Categories */}
          <div className="mb-6">
            <h4 className="text-sm font-medium text-foreground mb-3">
              Categorias
            </h4>
            <div className="space-y-2">
              {categories?.map((category) => (
                <div key={category?.id} className="flex items-center justify-between">
                  <Checkbox
                    label={category?.label}
                    checked={selectedCategories?.includes(category?.id)}
                    onChange={(e) => handleCategoryChange(category?.id, e?.target?.checked)}
                    size="sm"
                  />
                  <span className="text-xs text-muted-foreground">
                    {category?.count}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterSidebar;